/*

-*-*-*-*-*-*-*-* INFO -*-*-*-*-*-*-*-*

To get to know the code in more 
detail and understand how it works, 
you can look at the directives.

-*-*-*-*-*-*-*-* -*-*-*-*-*-*-*-*

*/

import BuildMethodsHEX from './HEXBuildMethods/BuildMethods.js'

export default class RandomHEX {
    constructor() {
        this.buildMethodObject = new BuildMethodsHEX()
    }

    randomHEXCode() {
        const HEXCodeColorfromBuild = this.buildMethodObject.getHEXCode(this.buildMethodObject.getStringfromArray())

        return HEXCodeColorfromBuild
    }
}